import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import timeUtils from '@/utils/time.js';
export default {
  props: {
    onSaleTime: Number,
    now: Number
  },
  watch: {
    now: function now() {
      this.updateTime();
    }
  },
  mounted: function mounted() {
    var timeInfo = this.getNowTime();
    this.timeInfo = timeInfo;
  },
  data: function data() {
    return {
      timeInfo: {}
    };
  },
  methods: {
    getNowTime: function getNowTime() {
      var now = this.now,
        onSaleTime = this.onSaleTime;
      var leftTime = onSaleTime - now;
      var leftDays = timeUtils.getLeftDays(leftTime);
      var leftHours = timeUtils.getLeftHours(leftTime);
      var leftMinutes = timeUtils.getLeftMinutes(leftTime);
      var leftSeconds = timeUtils.getLeftSeconds(leftTime);
      return {
        days: leftDays,
        hours: timeUtils._pad(leftHours),
        minutes: timeUtils._pad(leftMinutes),
        seconds: timeUtils._pad(leftSeconds)
      };
    },
    updateTime: function updateTime() {
      var timeInfo = this.getNowTime();
      this.timeInfo = timeInfo;
    }
  }
};